import React from 'react';
var css = {
  "chip": "rui-vPrj2",
  "text": "rui-3zv4i"
};
import Icon from '../Icon/Icon';
var Chip = function Chip(_ref) {
  var text = _ref.text,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: css.chip,
    onClick: onClick,
    onKeyPress: onClick,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("span", {
    className: css.text
  }, text), /*#__PURE__*/React.createElement(Icon, {
    icon: "cross",
    color: "blackIcons",
    size: 22
  }));
};
export default Chip;